export const gdpr = {
  routes: [
    {
      path: "/gdpr/roadmap",
      component: () => import("../organization-gdpr-roadmap-view"),
    },
  ],
};

export const kvkk = {
  routes: [
    {
      path: "/kvkk/roadmap",
      component: () => import("../organization-kvkk-roadmap-view"),
    },
  ],
};

export const ddo = {
  routes: [
    {
      path: "/ddo/roadmap",
      component: () => import("../organization-ddo-roadmap-view"),
    },
  ],
};

export const bgys = {
  routes: [
    {
      path: "/bgys/roadmap",
      component: () => import("../organization-bgys-roadmap-view"),
    },
  ],
};

export const organization = {
  routes: [
    {
      path: "/organization/roadmap",
      component: () => import("../organization-platform-roadmap-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/roadmap/platform",
      component: () => import("../management-platform-roadmap-view"),
    },
    {
      path: "/management/roadmap/gdpr",
      component: () => import("../management-gdpr-roadmap-view"),
    },
    {
      path: "/management/roadmap/kvkk",
      component: () => import("../management-kvkk-roadmap-view"),
    },
    {
      path: "/management/roadmap/bgys",
      component: () => import("../management-bgys-roadmap-view"),
    },
    {
      path: "/management/roadmap/ddo",
      component: () => import("../management-ddo-roadmap-view"),
    },
  ],
};
